module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABsUExURQAAAC8vVpxLVbqhpL9JWOOvtRIRISsIDcdebDYKD7KLkKNgaD8+cHZfg5Y3Q6x2fR0PG5EzP39+kNqXoL1EU+7P09B5hOW0ullYg9J+iezKzslkcGZljV5dh6alvGxIbkZFdU5Ne3pukbehtPzduwEAAAATdFJOUwCZmZn+/h0V/h2Zmf7/mZkdmZl5JkkSAAAAdklEQVQYGcXBSQLCIBAEwAZUFLJpXFqdMST+/49ecpgDnlOFTcXDajhZEY5syIacdlYHJ0oVUpaXFeA4cyYLp7fl4USpQpVlbyU41aJalO3TynAiFKFKO1o9Lp/Vd7R65HtVRnpUJfhjlUe4VQWcr1Ud4h/Y0g96ORcuiyCsUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/us.png
// module id = DERU
// module chunks = 1